import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "column",
    position: "relative",
    minHeight: 64,
    padding: "12px 16px",
    [theme.breakpoints.up("md")]: {
      minHeight: 72,
      padding: "16px 24px 0 24px",
    },
  },
  wrap: {
    display: "flex",
  },
  check: {
    flex: "0 0 32px",
    display: "flex",
    alignItems: "center",
  },
  search: {
    flex: "1",
    display: "flex",
    [theme.breakpoints.up("md")]: {
      flex: "0 0 300px",
      paddingRight: 8,
    },
  },
  actions: {
    flex: 1,
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sort: ({ sortWidth }: { sortWidth?: number }) => ({
    flex: sortWidth ? `0 0 ${sortWidth + 8}px` : undefined,
    display: "none",
    paddingLeft: 8,
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  }),
  more: {
    display: "flex",
    alignItems: "center",
    paddingLeft: 8,
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  tags: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: 6,
    "& > div": {
      marginTop: 6,
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: 12,
    },
  },
}));
